import { create } from "zustand";
import { CentralSlice, createCentralStore } from "./central.store";

interface CentralStoreTypes extends CentralSlice {}

export const useCentralStore = create<CentralStoreTypes>((...args) => ({
	...createCentralStore(...args),
}));
